/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
      $( document ).on( 'gform_page_loaded', function( event, formId, currentPage ) {
        if ( $( '#gform_page_' + formId + '_' + currentPage ).hasClass( 'final-page' ) ) {
          $( '.multipage-form__page--form-inner, .multipage-form__page--image-final' ).addClass( 'is-final' );
          $( '.multipage-form__footer' ).addClass( 'is-hidden' );
        } else {
          $( '.multipage-form__page--form-inner, .multipage-form__page--image-final' ).removeClass( 'is-final' );
          $( '.multipage-form__footer' ).removeClass( 'is-hidden' );
        }
      } );

      $( document ).on( 'change', '.gfield--type-image_choice input', function() {
        const field = $( this ).closest( '.gfield--type-image_choice' );

        $( field ).find( 'input' ).each( function( key, input ) {
          const choice = $( input ).closest( '.gchoice' );

          if ( $( input ).is( ':checked' ) ) {
            $( choice ).find( '.gfield-choice-image-wrapper' ).addClass( 'is-checked' );
          } else {
            $( choice ).find( '.gfield-choice-image-wrapper' ).removeClass( 'is-checked' );
          }
        } );
      } );

      document.addEventListener( 'gform/post_render', function( event ) {
        console.log( event.detail.formId );
        const form = document.getElementById( `gform_wrapper_${event.detail.formId}` );
        if ( !form ) return;

        const errors = form.querySelector( '.gform_validation_errors' );
        const page = form.querySelector( '.llgq-current-page .gform_page_fields' );
        console.log( errors );
        console.log( page );

        if ( errors && page ) {
          console.log( 'errors and page' );
          page.prepend( errors );
        }
      } );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'multipage-form', COMPONENT );
} )( app );
